// .u_page-content

(function ($) {
  var $pageContent = $('.u_page-content')
  $pageContent.each(function (i, pageContent) {
    pageContentInit($(pageContent))
  })

  function pageContentInit (pageContent) {
    var $container = pageContent.find('> .editor-content')
    // Add class to full width images
    $container.find('> p > img.alignnone, > p > img.aligncenter').each(function (index) {
      $(this).parent().addClass('u_featured-image')
    })
    $container.find('> div.alignnone, > div.aligncenter').each(function (index) {
      $(this).addClass('u_featured-image')
    })
  }
})(window.jQuery)
